module.exports = __webpack_public_path__ + "media/images/landing/ar/main@2x-ad18056fa2939535e3de2e6183caee11.png";